<script setup lang="ts">
import NotificationsAPI from "~/services/notifications";
import AppNotificationsDropdown from "./AppNotificationsDropdown.vue";

const emit = defineEmits<{
  clearAll: [];
  markAllAsRead: [];
  markAsRead: [id: string];
}>();

const { data: unreadCountData, refresh: refreshUnreadCount } = useAsyncData(
  "notifications-unread-count",
  () => NotificationsAPI.loadUnreadCount(),
);

const unreadCount = computed(() => unreadCountData.value ?? 0);
const hasUnreadNotifications = computed(() => unreadCount.value > 0);

const handleClearAll = (): void => {
  emit("clearAll");
};

const handleMarkAllAsRead = async (): Promise<void> => {
  emit("markAllAsRead");
  await refreshUnreadCount();
};

const handleMarkAsRead = async (id: string): Promise<void> => {
  emit("markAsRead", id);
  await refreshUnreadCount();
};
</script>

<template>
  <div class="flex items-center justify-center">
    <AppNotificationsDropdown
      @clear-all="handleClearAll"
      @mark-all-as-read="handleMarkAllAsRead"
      @mark-as-read="handleMarkAsRead"
    >
      <template #default="{ toggle }">
        <BaseButton
          type="icon"
          name="notifications"
          title="Notifications"
          class="text-secondary relative"
          @click="toggle"
        >
          <IconBell />
          <span
            v-if="hasUnreadNotifications"
            class="absolute -top-0.5 -right-0.5 font-bold flex items-center justify-center size-[0.875rem] rounded-full text-[9px] leading-none"
            :style="{
              backgroundColor: 'var(--base-error-color, #dc2626)',
              color: 'white',
            }"
          >
            {{ unreadCount > 99 ? '99+' : unreadCount }}
          </span>
        </BaseButton>
      </template>
    </AppNotificationsDropdown>
  </div>
</template>
